<script setup>
import { computed } from 'vue';

const props = defineProps({
  activity: {
    type: Object,
    required: true,
  },
  accountId: {
    type: [String, Number],
    default: '',
  },
  conversationDisplayId: {
    type: [String, Number],
    default: null,
  },
});

const conversationDisplayLink = computed(() => {
  if (!props.accountId || props.conversationDisplayId == null) return '';
  return `/app/accounts/${props.accountId}/conversations/${props.conversationDisplayId}`;
});

const showActivityContent = computed(() => {
  return (
    !props.activity?.systemAction &&
    props.activity?.content &&
    props.activity?.action !== 'Comentou' &&
    !props.activity?.oldValue
  );
});

const isConversationAssociation = computed(() => {
  return (
    showActivityContent.value &&
    props.activity?.action === 'Associou à conversa' &&
    !!conversationDisplayLink.value
  );
});
</script>

<template>
  <a
    v-if="isConversationAssociation"
    :href="conversationDisplayLink"
    target="_blank"
    rel="noopener noreferrer"
    class="text-sm font-medium text-n-blue-text hover:underline"
  >
    {{ activity.content }}
  </a>
  <span
    v-else-if="showActivityContent"
    class="text-sm font-medium text-n-slate-12"
  >
    {{ activity.content }}
  </span>
</template>
